export enum SignatureAction {
  Write = "write",
  Delete = "delete",
  Read = "read",
}
